<template>
  <div class="social-login-buttons">
    <div class="social-buttons-grid">
      <button 
        class="social-button google" 
        @click="handleSocialLogin('google')"
        :disabled="loading"
      >
        <span class="social-icon">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
        </span>
        <span class="social-text">{{ $t('auth.continueWithGoogle') }}</span>
      </button>

      <!-- Temporarily hidden - will be implemented in the future -->
      <!--
      <button 
        class="social-button github" 
        @click="handleSocialLogin('github')"
        :disabled="loading"
      >
        <span class="social-icon">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="#333" d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
        </span>
        <span class="social-text">Continue with GitHub</span>
      </button>

      <button 
        class="social-button linkedin" 
        @click="handleSocialLogin('linkedin')"
        :disabled="loading"
      >
        <span class="social-icon">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="#0077B5" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </span>
        <span class="social-text">Continue with LinkedIn</span>
      </button>

      <button 
        class="social-button wechat" 
        @click="handleWeChatLogin"
        :disabled="loading"
      >
        <span class="social-icon">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="#07C160" d="M9.036 8.035c-.447 0-.81.363-.81.81 0 .447.363.81.81.81.447 0 .81-.363.81-.81 0-.447-.363-.81-.81-.81zm5.928 0c-.447 0-.81.363-.81.81 0 .447.363.81.81.81.447 0 .81-.363.81-.81 0-.447-.363-.81-.81-.81z"/>
            <path fill="#07C160" d="M19.385 4.141A9.599 9.599 0 0 0 12 2.25c-4.695 0-8.5 3.805-8.5 8.5 0 1.702.502 3.285 1.365 4.605l-1.272 4.375 4.495-1.247a8.56 8.56 0 0 0 3.912.942c4.695 0 8.5-3.805 8.5-8.5 0-2.29-.907-4.367-2.385-5.884zM12 18.75a7.2 7.2 0 0 1-3.675-.99l-.27-.162-2.82.782.75-2.58-.176-.275a7.2 7.2 0 0 1-1.08-3.855c0-3.98 3.22-7.2 7.2-7.2 1.925 0 3.67.755 4.965 1.985A7.158 7.158 0 0 1 19.2 10.75c0 3.98-3.22 7.2-7.2 7.2z"/>
          </svg>
        </span>
        <span class="social-text">Continue with WeChat</span>
      </button>
      -->
    </div>

    <div class="divider">
      <span class="divider-text">{{ $t('auth.or') }}</span>
    </div>

    <!-- WeChat QR Code Modal -->
    <div v-if="showWeChatModal" class="wechat-modal-overlay" @click="closeWeChatModal">
      <div class="wechat-modal" @click.stop>
        <div class="modal-header">
          <h3>{{ $t('auth.wechatLogin') }}</h3>
          <button class="close-button" @click="closeWeChatModal">×</button>
        </div>
        
        <div class="modal-content">
          <div v-if="wechatLoading" class="loading-state">
            <div class="spinner"></div>
            <p>{{ $t('auth.generatingQR') }}</p>
          </div>
          
          <div v-else-if="wechatError" class="error-state">
            <p class="error-message">{{ wechatError }}</p>
            <button class="retry-button" @click="generateWeChatQRCode">{{ $t('credits.retry') }}</button>
          </div>
          
          <div v-else class="qr-code-container">
            <div class="qr-code-wrapper">
              <img :src="wechatQRCodeUrl" :alt="$t('auth.wechatQRAlt')" class="qr-code-image" />
              
              <div v-if="wechatStatus === 'pending'" class="qr-status pending">
                <div class="status-indicator"></div>
                <p>{{ $t('auth.scanQRWithWeChat') }}</p>
              </div>
              
              <div v-else-if="wechatStatus === 'scanned'" class="qr-status scanned">
                <div class="status-indicator"></div>
                <p>{{ $t('auth.qrScannedConfirm') }}</p>
              </div>
              
              <div v-else-if="wechatStatus === 'confirmed'" class="qr-status confirmed">
                <div class="status-indicator"></div>
                <p>Login confirmed! Redirecting...</p>
              </div>
              
              <div v-else-if="wechatStatus === 'expired'" class="qr-status expired">
                <div class="status-indicator"></div>
                <p>QR code expired. Please try again.</p>
                <button class="retry-button" @click="generateWeChatQRCode">Generate New QR Code</button>
              </div>
            </div>
            
            <div class="qr-instructions">
              <h4>How to login:</h4>
              <ol>
                <li>Open WeChat on your phone</li>
                <li>Tap <strong>Discover</strong> → <strong>Scan</strong></li>
                <li>Scan the QR code above</li>
                <li>Confirm login on your phone</li>
              </ol>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <p class="expiry-notice" v-if="wechatExpiresIn">
            QR code expires in {{ Math.floor(wechatExpiresIn / 60) }}:{{ (wechatExpiresIn % 60).toString().padStart(2, '0') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth'
import authApiService from '../services/authApi'

export default {
  name: 'SocialLoginButtons',
  props: {
    mode: {
      type: String,
      default: 'login', // 'login' or 'register'
      validator: (value) => ['login', 'register'].includes(value)
    }
  },
  data() {
    return {
      loading: false,
      showWeChatModal: false,
      wechatLoading: false,
      wechatError: null,
      wechatQRCodeUrl: '',
      wechatQRCodeId: '',
      wechatStatus: 'pending',
      wechatExpiresIn: 0,
      statusCheckInterval: null
    }
  },
  methods: {
    async handleSocialLogin(provider) {
      this.loading = true
      
      try {
        console.log(`Initiating ${provider} login...`)
        
        // Handle Google OAuth
        if (provider === 'google') {
          try {
            // Get OAuth URL from backend
            const response = await authApiService.getGoogleOAuthUrl()
            
            if (response.success && response.authUrl) {
              // Store state in sessionStorage for validation after redirect
              if (response.state) {
                sessionStorage.setItem('oauth_state', response.state)
                sessionStorage.setItem('oauth_provider', provider)
              }
              
              // Redirect to Google OAuth
              window.location.href = response.authUrl
              return // Don't set loading to false, we're redirecting
            } else {
              throw new Error('Failed to get OAuth URL')
            }
          } catch (error) {
            console.error('Google OAuth URL error:', error)
            throw new Error(`Failed to initiate Google login: ${error.message}`)
          }
        }
        
        // For other providers (GitHub, LinkedIn), show message that they're not yet implemented
        // These can be implemented similarly to Google
        alert(`Note: ${provider} OAuth integration is not yet fully implemented. Please use Google login or email/password authentication.`)
        this.loading = false
        
      } catch (error) {
        console.error(`${provider} login error:`, error)
        this.$emit('social-error', {
          provider,
          error: error.message
        })
        this.loading = false
      }
    },
    
    async handleWeChatLogin() {
      this.showWeChatModal = true
      await this.generateWeChatQRCode()
    },
    
    async generateWeChatQRCode() {
      this.wechatLoading = true
      this.wechatError = null
      
      try {
        // In a real implementation, this would call the backend API
        // const response = await this.$api.get('/api/auth/wechat/qrcode')
        // const { qrCodeId, qrCodeUrl, expiresIn } = response.data
        
        // Mock response for demo
        const mockResponse = {
          qrCodeId: 'mock_qr_' + Date.now(),
          qrCodeUrl: `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
            JSON.stringify({
              type: 'wechat_login',
              id: 'mock_qr_' + Date.now(),
              app: 'ai4resume',
              timestamp: Date.now()
            })
          )}`,
          expiresIn: 300 // 5 minutes
        }
        
        this.wechatQRCodeId = mockResponse.qrCodeId
        this.wechatQRCodeUrl = mockResponse.qrCodeUrl
        this.wechatExpiresIn = mockResponse.expiresIn
        this.wechatStatus = 'pending'
        
        // Start checking QR code status
        this.startStatusCheck()
        
      } catch (error) {
        console.error('WeChat QR code generation error:', error)
        this.wechatError = error.message || 'Failed to generate QR code'
      } finally {
        this.wechatLoading = false
      }
    },
    
    startStatusCheck() {
      // Clear any existing interval
      if (this.statusCheckInterval) {
        clearInterval(this.statusCheckInterval)
      }
      
      // Check status every 2 seconds
      this.statusCheckInterval = setInterval(async () => {
        if (this.wechatStatus === 'confirmed' || this.wechatStatus === 'expired') {
          clearInterval(this.statusCheckInterval)
          return
        }
        
        // Update expiry timer
        if (this.wechatExpiresIn > 0) {
          this.wechatExpiresIn--
        } else {
          this.wechatStatus = 'expired'
          clearInterval(this.statusCheckInterval)
          return
        }
        
        // In a real implementation, this would call the backend API
        // const response = await this.$api.get(`/api/auth/wechat/qrcode/${this.wechatQRCodeId}`)
        // const { status } = response.data
        
        // Mock status updates for demo
        const mockStatuses = ['pending', 'scanned', 'confirmed']
        const currentIndex = mockStatuses.indexOf(this.wechatStatus)
        
        // Randomly progress through statuses for demo
        if (currentIndex < mockStatuses.length - 1 && Math.random() > 0.7) {
          this.wechatStatus = mockStatuses[currentIndex + 1]
          
          // If confirmed, simulate successful login
          if (this.wechatStatus === 'confirmed') {
            setTimeout(() => {
              this.$emit('social-login', {
                provider: 'wechat',
                success: true,
                message: 'WeChat login successful (demo)'
              })
              this.closeWeChatModal()
            }, 1000)
          }
        }
      }, 2000)
    },
    
    closeWeChatModal() {
      this.showWeChatModal = false
      this.wechatLoading = false
      this.wechatError = null
      this.wechatQRCodeUrl = ''
      this.wechatQRCodeId = ''
      this.wechatStatus = 'pending'
      this.wechatExpiresIn = 0
      
      if (this.statusCheckInterval) {
        clearInterval(this.statusCheckInterval)
        this.statusCheckInterval = null
      }
    }
  },
  beforeUnmount() {
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval)
    }
  }
}
</script>

<style scoped>
.social-login-buttons {
  width: 100%;
}

.social-buttons-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.social-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.social-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.social-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.social-button.google {
  border-color: #4285F4;
  color: #4285F4;
  display: none; /* Hide Google auth button */
}

.social-button.google:hover:not(:disabled) {
  background-color: #f8f9ff;
  border-color: #3367d6;
}

.social-button.github {
  border-color: #333;
  color: #333;
}

.social-button.github:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #222;
}

.social-button.linkedin {
  border-color: #0077B5;
  color: #0077B5;
}

.social-button.linkedin:hover:not(:disabled) {
  background-color: #f0f8ff;
  border-color: #00669c;
}

.social-button.wechat {
  border-color: #07C160;
  color: #07C160;
}

.social-button.wechat:hover:not(:disabled) {
  background-color: #f0fff5;
  border-color: #06a952;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-text {
  flex: 1;
  text-align: center;
}

.divider {
  display: none; /* Hide divider as there are no visible social login buttons */
  align-items: center;
  margin: 20px 0;
  color: #666;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #ddd;
}

.divider-text {
  padding: 0 16px;
  font-size: 14px;
  color: #666;
}

/* WeChat Modal Styles */
.wechat-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.wechat-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-button:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-content {
  padding: 20px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #07C160;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-state {
  text-align: center;
  padding: 40px 20px;
}

.error-message {
  color: #dc3545;
  margin-bottom: 20px;
}

.retry-button {
  padding: 8px 20px;
  background: #07C160;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}

.retry-button:hover {
  background: #06a952;
}

.qr-code-container {
  text-align: center;
}

.qr-code-wrapper {
  margin-bottom: 24px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px;
  background: white;
  margin-bottom: 16px;
}

.qr-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.qr-status.pending .status-indicator {
  background: #ffc107;
}

.qr-status.scanned .status-indicator {
  background: #17a2b8;
}

.qr-status.confirmed .status-indicator {
  background: #28a745;
}

.qr-status.expired .status-indicator {
  background: #dc3545;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.qr-instructions {
  text-align: left;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-top: 20px;
}

.qr-instructions h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #333;
}

.qr-instructions ol {
  margin: 0;
  padding-left: 20px;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.qr-instructions li {
  margin-bottom: 8px;
}

.qr-instructions strong {
  color: #333;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}

.expiry-notice {
  margin: 0;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
</style>
